import { render, staticRenderFns } from "./UsersTop.vue?vue&type=template&id=034af7a7&scoped=true&"
import script from "./UsersTop.vue?vue&type=script&lang=js&"
export * from "./UsersTop.vue?vue&type=script&lang=js&"
import style0 from "./UsersTop.vue?vue&type=style&index=0&id=034af7a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034af7a7",
  null
  
)

export default component.exports